/* src/app/modules/search/shared/components/email-info/email-info.component.scss */
.text-ellipsis {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
/*# sourceMappingURL=email-info.component.css.map */
